import React from 'react'

const Logout = () => {


    const handleLogout = () => {
        // Supprime les infos locales
        localStorage.removeItem("isAdmin");
        localStorage.removeItem("adminUsername");

        // (optionnel) Si tu veux détruire la session PHP aussi :
        fetch("https://centrex.amservices.eu/api/logout.php", {
            method: "POST",
            credentials: "include",
        }).catch(() => { });

        // Redirige vers la page de login
        window.location.href = "/login";
    };
    return (
        <button className="logout-btn" onClick={handleLogout}>
            Se déconnecter
        </button>
    )
}

export default Logout